export default __webpack_public_path__ + "static/About_us_Objective_Icon2-ad1c2e444f7bfb021069d37ff9296d96.png";